export default __webpack_public_path__ + "static/media/1.d6f04762.png";